import React, { useContext } from 'react'
import { ThemeContext } from "../../Context/ThemeContext.js";
import './Trustedpricing.css'
import Vector from '../../images/VectorTriangles.png'
const Trustedpricing = () => {
    const theme = useContext(ThemeContext);
    const darkMode = theme.state.darkMode;


    return (
        <div className='TrustedPricing'>
            <div className="vector-div">
                <img src={Vector} alt="" />
                <div className="txtbox">
                    <span className="txt">
                        TVL
                    </span>
                    <span className="price">
                        $294,449
                    </span>
                </div>
                <div className={`${darkMode ? 'dark-rect' : 'light-rect'}`}></div>
                <div className="txtbox">
                    <span className="txt">
                        TVL
                    </span>
                    <span className="price">
                        $294,449
                    </span>
                </div>
                <div className={`${darkMode ? 'dark-rect' : 'light-rect'}`}></div>
                <div className="txtbox">
                    <span className="txt">
                        TVL
                    </span>
                    <span className="price">
                        $294,449
                    </span>
                </div>
            </div>
        </div>
    )
}

export default Trustedpricing